var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-box" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.showSpinner
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.showSpinner
        ? _c(
            "b-tabs",
            {
              attrs: {
                vertical: "",
                "content-class": "col-12 col-md-9 mt-1 mt-md-0",
                pills: "",
                "nav-wrapper-class": "col-md-3 col-12",
                "nav-class": "nav-left",
              },
            },
            [
              _vm.IsAdmin()
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "ToolIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Set Up My Account")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1037610691
                      ),
                    },
                    [_c("AccountSetUp", { on: { goToTab: _vm.goToTab } })],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                {
                  attrs: { active: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "UserIcon", size: "18" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("General"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    421883502
                  ),
                },
                [
                  _c("account-setting-general", {
                    attrs: { "general-data": _vm.options },
                  }),
                ],
                1
              ),
              _c(
                "b-tab",
                {
                  attrs: {
                    active:
                      _vm.isAccountSettingRoute &&
                      (_vm.activeTab == undefined || _vm.activeTab == null),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "LockIcon", size: "18" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Change Password"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2672128059
                  ),
                },
                [_c("account-setting-password")],
                1
              ),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "LockIcon", size: "18" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("My Permissions"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3951641518
                  ),
                },
                [
                  _c("account-setting-permissions", {
                    attrs: { permissions: _vm.permissions },
                  }),
                ],
                1
              ),
              _vm.IsAdmin()
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "InfoIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Audit Logs")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2769168349
                      ),
                    },
                    [
                      _c("account-setting-information", {
                        attrs: { informationData: _vm.logs },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.IsAdmin() &&
              _vm.HasPermission(_vm.PermissionList.Inventory_View)
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "InfoIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Units of Measure")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4069070915
                      ),
                    },
                    [_c("account-setting-uom")],
                    1
                  )
                : _vm._e(),
              _vm.IsAdmin() &&
              _vm.HasPermission(_vm.PermissionList.Marketing_View)
                ? _c(
                    "b-tab",
                    {
                      attrs: { active: _vm.activeTab == "facebook" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "LockIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("My Social")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1851896845
                      ),
                    },
                    [_c("AccountAppid")],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "UploadIcon", size: "18" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Upload / Download Center"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    960756857
                  ),
                },
                [_c("UploadCenter")],
                1
              ),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "UsersIcon", size: "18" },
                            }),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Labours"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2526497151
                  ),
                },
                [_c("b-card", [_c("LabourComponent")], 1)],
                1
              ),
              _vm.IsAdmin()
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "SettingsIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Custom Fields")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1969568046
                      ),
                    },
                    [_c("CustomFields")],
                    1
                  )
                : _vm._e(),
              _vm.IsAdmin()
                ? _c(
                    "b-tab",
                    {
                      attrs: { active: _vm.activeTab == "companySettings" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "SettingsIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Company Settings")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        395890222
                      ),
                    },
                    [_c("AccountSettingCompanySettings")],
                    1
                  )
                : _vm._e(),
              _vm.IsAdmin()
                ? _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "SettingsIcon", size: "18" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Transaction Setting")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1978831294
                      ),
                    },
                    [_c("Invoice")],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }